import React from 'react'
import { Link, useNavigate } from 'react-router'

function AddTestimonials() {
    const navigate = useNavigate()
    return (
        <div>
            <div className="d-md-flex d-block align-items-center justify-content-between  page-header-breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-swmibold">Add Testimonials</h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item active" aria-current="page">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <a href="javascript:void(0);">Add Testimonials</a>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <button
                        onClick={() => navigate(-1)}
                        className="btn btn-primary"
                    >
                        Testimonial List
                    </button>
                </div>

            </div>

            {/* Form Design */}
            <div className="card">
                <div className="card-body">
                    <div className="container">
                        <div className="row g-3">

                            {/* Profile Upload */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Profile</label>
                                    <input
                                        type="file"
                                        className="form-control custumform"
                                    />
                                </div>
                            </div>

                            {/* Name */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        className="form-control custumform"
                                        placeholder="Enter Name"
                                    />
                                </div>
                            </div>

                            {/* Designation */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Designation</label>
                                    <input
                                        type="text"
                                        className="form-control custumform"
                                        placeholder="Enter Designation"
                                    />
                                </div>
                            </div>

                            {/* Status */}
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Status</label>
                                    <select className="form-control custumform">
                                        <option>Select Status</option>
                                        <option>Active</option>
                                        <option>Inactive</option>
                                    </select>
                                </div>
                            </div>

                            {/* Description */}
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea
                                        rows="4"
                                        className="form-control custumform"
                                        placeholder="Enter Description"
                                    ></textarea>
                                </div>
                            </div>

                            {/* Submit Button */}
                            <div className="col-md-12 d-flex justify-content-end">
                                <div className="button_submit mt-3">
                                    <button className="btn btn-primary">
                                        Submit
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddTestimonials